import { render } from "./DashboardCardBig.vue?vue&type=template&id=c27c1328"
import script from "./DashboardCardBig.vue?vue&type=script&lang=js"
export * from "./DashboardCardBig.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__